<template>
  <section class="content">
    <div class="box box-info">
        <fiscalYearDialog ref="fyDialog"/>
        <fiscalyearList @delete-message="deleteMessage" @edit-fiscalYear="editFiscalYear"/>
      </div>
  </section>
</template>
<script>
import fiscalYearDialog from '../settingDialog/fiscalYearDialog.vue'
import fiscalyearList from './fiscalyearList.vue'
export default {
  name: 'fiscalYear',
  data() {
    return {
    }
  },
  methods: {
    editFiscalYear(data) {
      this.$refs.fyDialog.editFiscalYear(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    fiscalYearDialog,
    fiscalyearList
  }
}
</script>



// WEBPACK FOOTER //
// fiscalYear.vue?5686e820